import { Partner, Society } from 'types';

export default function getPartner(partnerId: string, actualSociety: Society) {
  return actualSociety?.partners?.find(
    (partner: Partner) => partner?._id === partnerId
  );
}
